import { Component, OnInit, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { InputComponent } from '../input/input.component';
import { BooleanQualifierService } from 'src/app/model/api-services/qualifiers/boolean-qualifier.service';
import { SLLayer } from 'src/app/model/sl-layer';
import { AttributeInfo } from 'src/app/types/@types/sl-v-types';

@Component({
	selector: 'app-boolean-input',
	templateUrl: './boolean-input.component.html',
	styleUrls: ['./boolean-input.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class BooleanInputComponent
	extends InputComponent
	implements OnInit {

	public useRadioButtons = false;
	public displayHorizontal = false;
	public displayVertical = false;
	public useToggle = false;
	public onLabel = '';
	public offLabel = '';

	public set currentValue(val: any) {
		let boolVal: boolean = null;
		switch (typeof (val)) {
			case 'number':
				boolVal = BooleanQualifierService.FromNumber(val);
				break;
			case 'string':
				switch (val) {
					case 't':
					case 'f':
						boolVal = (val === 't');
						break;
				}
				if (boolVal === null) {
					if (this.hasCasting === true) {
						if (isNaN(Number(val))) {
							boolVal = BooleanQualifierService.FromString(val as string, this.attribute.casting.entry.boolean);
						} else {
							boolVal = BooleanQualifierService.FromNumber(Number(val));;
						}
					} else {
						boolVal = (val === 't');
					}
				}

				break;
			case 'boolean':
				boolVal = val;
				break;
			default:
				boolVal = false;
		}
		switch (this.attribute.type) {
			case 'text':
			case 'string':
				if (this.hasCasting === true) {
					super.currentValue = BooleanQualifierService.ToString(boolVal, this.attribute.casting.entry.boolean);
					break;
				} else {
					super.currentValue = (boolVal === true) ? 't' : 'f';
				}
				return;
			case 'boolean':
				super.currentValue = (boolVal === true) ? 't' : 'f';
				return;
			case 'int':
			case 'float':
				super.currentValue = (boolVal === true) ? 1 : 0;
				return;
			default:
				return;
		}
	}
	public get currentValue(): any {
		switch (super.GetSuperValue()) {
			case 't':
			case 'f':
				return super.GetSuperValue();
			case 1:
				return 't';
			case 0:
				return 'f';
		}
		if (this.hasCasting === true) {
			switch (this.attribute.type) {
				case 'text':
				case 'string':
					const boolVal = BooleanQualifierService.FromString(super.GetSuperValue() as string, this.attribute.casting.entry.boolean);
					return (boolVal === true) ? 't' : 'f';
			}

		}
		return super.GetSuperValue();
	}
	constructor(private domNode: ElementRef,protected cdr:ChangeDetectorRef) {
		super(cdr);
		super._domNode = this.domNode;
	}

	SetAttribute(layer: SLLayer, attribute: AttributeInfo) {
		super.SetAttribute(layer, attribute);
		if (!!attribute.casting) {
			if (!!attribute.casting.entry) {
				this.onLabel = '' + attribute.casting.entry.boolean.trueValue;
				this.offLabel = '' + attribute.casting.entry.boolean.falseValue;
				switch (attribute.casting.entry.boolean.labelMode) {
					case 'radio-buttons':
						this.useToggle = false;
						this.useRadioButtons = true;
						this.displayHorizontal = false;
						this.displayVertical = true;
						break;
					case 'radio-buttons-h':
						this.useToggle = false;
						this.useRadioButtons = true;
						this.displayHorizontal = true;
						this.displayVertical = false;
						break;
					case 'toggle-switch':
						this.useToggle = true;
						this.useRadioButtons = false;
						this.displayHorizontal = false;
						this.displayVertical = false;
				}
			}
		}
		this.currentValue = this.currentValue;
	}
	Select(trueOrFalse: boolean) {
		this.currentValue = trueOrFalse;
	}
	Reset(): void {
		super.Reset();
		this.onLabel = 'On';
		this.offLabel = 'Off';
		this.useToggle = true;
		this.useRadioButtons = false;
		this.displayHorizontal = false;
		this.displayVertical = false;

	}
	Update(newVal: string) {
		this.currentValue = newVal;
	}
	ngOnInit(): void {
		super.ngOnInit();
	}

}
